import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

/**
 * Created by Jerker Nord on 2021-04-30.
 */

export class TrueGritStatics {

    public static defaultGameAreaSize:number[] = [4, 4, 4, 4, 4, 4];
    public static symbolWidth:number = 120;
    public static symbolHeight:number = 120;

    //All in total spin time
    public static topReelAllInTotalSpinDuration:number = 0.3;//0.6
    public static topReelAllInTotalSpinDurationFastSpin:number = 0.25;//0.2
    public static mainAllInTotalSpinDuration:number = 0.29;//0.9
    public static mainAllInTotalSpinDurationFastSpin:number = 0.2;//0.9
    public static bottomReelAllInTotalSpinDuration:number = 0.35;//0.6
    public static bottomReelAllInTotalSpinDurationFastSpin:number = 0.25//0.3

    //All out total spin time
    public static topReelAllOutTotalSpinDuration:number = 0.45;//0.59
    public static topReelAllOutTotalSpinDurationFastSpin:number = 0.2;//0.49
    public static mainReelAllOutTotalSpinDuration:number = 0.3;//0.6
    public static mainReelAllOutTotalSpinDurationFastSpin:number = 0.2;//0.5
    public static bottomReelAllOutTotalSpinDuration:number = 0.35;//0.75
    public static bottomReelAllOutTotalSpinDurationFastSpin:number = 0.2;//0.65

    //Delay between reels, all in (on top and bottom, this is the delay before they spin in)
    public static topReelAllInStopDelay:number = 0.09;//0.42
    public static topReelAllInStopDelayFastSpin:number = 0.03;//0.12;
    public static mainReelAllInStopDelay:number = 0.06;
    public static mainReelAllInStopDelayFastSpin:number = 0.02;
    public static bottomReelAllInStopDelay:number = 0.09;//0.42
    public static bottomReelAllInStopDelayFastSpin:number = 0.032;//0.68;

    //Delay between reels, all out
    public static topReelAllOutStopDelay:number = 0.05;
    public static topReelAllOutStopDelayFastSpin:number = 0;
    public static mainReelAllOutStopDelay:number = 0.06;
    public static mainReelAllOutStopDelayFastSpin:number = 0.03;
    public static bottomReelAllOutStopDelay:number = 0.1;
    public static bottomReelAllOutStopDelayFastSpin:number = 0;

    //Blur delay, all in
    public static topReelAllInBlurDelay:number = 0.22;
    public static topReelAllInBlurDelayFastSpin:number = 0.10;
    public static mainReelAllInBlurDelay:number = 0.22;//0.84
    public static mainReelAllInBlurDelayFastSpin:number = 0.010;//0.80
    public static bottomReelAllInBlurDelay:number = 0.22;
    public static bottomReelAllInBlurDelayFastSpin:number = 0.10;

    //Spin-in gap between symbols
    public static topReelSpinStopSymbolDelay:number = 0.02;
    public static mainReelSpinStopSymbolDelay:number = 0.04;
    public static mainReelSpinStopSymbolDelayFastSpin:number = 0.02;
    public static bottomReelSpinStopSymbolDelay:number = 0.02;

    //Spin-out gap between symbols
    public static topReelSpinStartSymbolDelay:number = 0.01;
    public static mainReelSpinStartSymbolDelay:number = 0.03;

    //Blur delay, all out
    public static topReelAllOutBlurDelay:number = 0.05;
    public static topReelAllOutBlurDelayFastSpin:number = 0;
    public static mainReelAllOutBlurDelay:number = 0.1;
    public static mainReelAllOutBlurDelayFastSpin:number = 0.05;
    public static bottomReelAllOutBlurDelay:number = 0.05;
    public static bottomReelAllOutBlurDelayFastSpin:number = 0;

    public static topReelSpinFillUpSymbolDelay:number = 0.03;

    //Near win anticipation
    public static nearWinSpinInGapDelay:number = 0.6;

    public static reelPositions:PIXI.Point[] = [
        new PIXI.Point(TrueGritStatics.symbolWidth * 0, 0),
        new PIXI.Point(TrueGritStatics.symbolWidth * 1, 0),
        new PIXI.Point(TrueGritStatics.symbolWidth * 2, 0),
        new PIXI.Point(TrueGritStatics.symbolWidth * 3, 0),
        new PIXI.Point(TrueGritStatics.symbolWidth * 4, 0),
        new PIXI.Point(TrueGritStatics.symbolWidth * 5, 0)
    ];
    public static PORTRAIT_Y_OFFSET:number = 360;
    public static TOP_REEL_VIEW_POSITION:PIXI.Point = new PIXI.Point(-13, 74);
    public static TOP_REEL_VIEW_MASK_POSITION:PIXI.Point = new PIXI.Point(128, 18);
    public static BOTTOM_REEL_VIEW_POSITION:PIXI.Point = new PIXI.Point(107, 557);
    public static BOTTOM_REEL_VIEW_MASK_POSITION:PIXI.Point = new PIXI.Point(130, 10);
    public static MAIN_REELS_VIEW_POSITION:PIXI.Point = new PIXI.Point(-14, 192);
    public static MAIN_REELS_VIEW_MASK_POSITION:PIXI.Point = new PIXI.Point(5, 14);
    public static SYMBOL_BOX_VIEW_POSITION:PIXI.Point = new PIXI.Point(-62, 147);
    public static WAYS_VIEW_POSITION:PIXI.Point = new PIXI.Point(614, 127);
    public static TOTAL_WIN_VIEW_POSITION:PIXI.Point = new PIXI.Point(0, 0);
    public static transformSymbolWiggle = CustomWiggle.create("transformSymbolWiggle", {
        wiggles : 60,
        amplitudeEase : Linear.easeNone,
        timingEase : Linear.easeNone,
    });

    //Easing
    public static bombShakeWiggleX = CustomWiggle.create("bombShakeWiggleX", {
        wiggles:4,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static bombShakeWiggleY = CustomWiggle.create("bombShakeWiggleY", {
        wiggles:2,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static reelLandingShake = CustomWiggle.create("reelLandingShake", {
        wiggles:1,
        type:"easeOut"
    });

    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:50,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });
    public static bigWinAnticipationWiggle2 = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:40,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static m0Hit100Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 60,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
    public static m0Hit500Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
    public static m0HitMoreThan500Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
}